._container_115sl_1 {
  margin-left: 20px;
  margin-right: 20px;
  padding: 20px;
  background: var(--chat-message-ai-bg-color);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 100%; }

._content_115sl_10 {
  color: var(--text-color) !important; }

._deny_115sl_13 {
  font-weight: bold; }

._root_115sl_16 ._consentOverlay_115sl_16 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(51, 56, 83, 0.48);
  z-index: 1;
  height: 0;
  transition: opacity 0.5s, height 0.5s 0.5s;
  opacity: 0; }

._root_115sl_16 ._consentWrapper_115sl_28 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  box-shadow: 0px 10px 24px 0px rgba(0, 6, 36, 0.08);
  opacity: 0;
  transform: translateY(100%);
  transition: opacity 0.5s, transform 0.5s; }

._root_115sl_16._visible_115sl_39 ._consentOverlay_115sl_16 {
  height: 100%;
  opacity: 1;
  transition: opacity 0.5s; }

._root_115sl_16._visible_115sl_39 ._consentWrapper_115sl_28 {
  transition: opacity 0.5s 0.5s, transform 0.5s 0.5s;
  opacity: 1;
  transform: translateY(0); }

._statusBoxContainer_115sl_49 {
  background: #f8f9fa;
  border-radius: 4px;
  overflow: hidden; }

._statusBox_115sl_49 {
  width: 100%; }
  ._statusBox_115sl_49 ._statusText_115sl_56 {
    padding-top: 16px;
    padding-bottom: 16px; }
  ._statusBox_115sl_49 ._statusColor_115sl_59 {
    width: 4px;
    height: 100%; }

._loader_115sl_63 {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px; }

._defaultState_115sl_70 {
  background: #ffc23d; }

._approved_115sl_73 {
  background: #51b77b; }

._denied_115sl_76 {
  background: #ff3d3d; }
